import React from 'react'
import { observer } from 'mobx-react'
import { LS_SPORT_ID_ICON_MAP, SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import { MatchMarketSlotProps } from '@views/Popup/SameMatch'
import { SelectMatchListWrap } from '@styles/match.style'
import { isLsportsEnv } from '@utils/utils'

export const MatchMaketSlot: React.FC<MatchMarketSlotProps> = (props: MatchMarketSlotProps) => {

  const {
    sportId,
    homeTeamName,
    awayTeamName,
    marketName,
    outcomeName,
    rate,
  } = props

  return (
    <SelectMatchListWrap>
      <div className="match-team">
        {isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[sportId] : SPORT_ID_ICON_MAP[sportId]}
        <span className="match-team--name">{homeTeamName}</span>
        <span className="match-team--vs">vs</span>
        <span className="match-team--name">{awayTeamName}</span>
      </div>
      <div className="match-type">
        [{marketName}]
      </div>
      <div className="select-wrap">
        <span className="point">{outcomeName}</span>
        <span className="value">{rate.toFixed(2)}</span>
      </div>
    </SelectMatchListWrap>
  )
}


export default observer(MatchMaketSlot)
